var _path;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgDummySquare = function SvgDummySquare(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 9.2002V14.8002C6 15.9203 6 16.4801 6.21799 16.9079C6.40973 17.2842 6.71547 17.5905 7.0918 17.7822C7.5192 18 8.07899 18 9.19691 18H14.8031C15.921 18 16.48 18 16.9074 17.7822C17.2837 17.5905 17.5905 17.2842 17.7822 16.9079C18 16.4805 18 15.9215 18 14.8036V9.19691C18 8.07899 18 7.5192 17.7822 7.0918C17.5905 6.71547 17.2837 6.40973 16.9074 6.21799C16.4796 6 15.9203 6 14.8002 6H9.2002C8.08009 6 7.51962 6 7.0918 6.21799C6.71547 6.40973 6.40973 6.71547 6.21799 7.0918C6 7.51962 6 8.08009 6 9.2002Z",
    stroke: "#282830",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDummySquare, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Dummy_Square.015c5a78.svg";
export { ForwardRef as ReactComponent };